module.exports = __webpack_public_path__ + "img/corra-logo.503a732a.svg";